import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { CheckCircleIcon, SearchIcon, FileTextIcon } from 'lucide-react';
export function AboutStandards() {
  const standards = [{
    name: 'FDA Approved Devices',
    icon: CheckCircleIcon
  }, {
    name: 'Rigorous Selection',
    icon: SearchIcon
  }, {
    name: 'Strict Protocols',
    icon: FileTextIcon
  }];
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-116">
      <div className="max-w-[900px] mx-auto px-6 lg:px-8" data-id="element-117">
        <AnimateOnScroll className="text-center" data-id="element-118">
          <h2 className="text-[28px] sm:text-4xl lg:text-[44px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-119">
            EVIDENCE-BASED EXCELLENCE
          </h2>

          <div className="w-[60px] h-[2px] bg-[#FF1493] mx-auto mb-10" data-id="element-120"></div>

          <p className="text-black text-base lg:text-lg leading-[1.8] font-body mb-16" data-id="element-121">
            We go where the evidence is—every treatment we offer and device we
            use undergoes a rigorous selection process and is either FDA
            approved or has been used for many years in clinical environments.
            Our decisions are based on safety and efficacy and what studies have
            been done to ensure that our patients get the best quality outcome.
            Every member of our Be CLINICAL staff follows strict protocols and
            parameters with an unmatched dedication to great patient outcomes.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12" data-id="element-122">
            {standards.map((standard, index) => <div key={index} className="flex flex-col items-center gap-4" data-id="element-123">
                <div className="w-16 h-16 rounded-full bg-black flex items-center justify-center relative group transition-transform hover:scale-105" data-id="element-124">
                  <div className="absolute inset-0 rounded-full border-2 border-[#FF1493] opacity-0 group-hover:opacity-100 scale-110 transition-all" data-id="element-125"></div>
                  <standard.icon className="text-white" size={32} strokeWidth={1.5} data-id="element-126" />
                </div>
                <span className="text-black font-heading uppercase tracking-widest text-sm font-medium" data-id="element-127">
                  {standard.name}
                </span>
              </div>)}
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}